import type { WorkspaceResponseDto } from '@monksflow/platform-api-sdk';
import { useTranslation } from 'react-i18next';

import type { WorkspaceAccess } from '../../model/tools.types';
import { WorkspaceChipList } from './WorkspaceChipList';

interface WorkspaceAccessCellProps {
  workspaceAccess: WorkspaceAccess;
  workspaces: WorkspaceResponseDto[];
  /** A reach the access modes cannot express, such as "Only you", shown in place of them. */
  label?: string;
}

export function WorkspaceAccessCell({
  workspaceAccess,
  workspaces,
  label,
}: WorkspaceAccessCellProps) {
  const { t } = useTranslation('admin');

  if (label) return <span className="text-body-md text-muted-foreground">{label}</span>;

  if (workspaceAccess === 'all') {
    return (
      <span className="text-body-md text-muted-foreground">
        {t('admin.workspaceAccessChips.all')}
      </span>
    );
  }

  if (workspaceAccess === 'none') {
    return (
      <span className="text-body-md text-destructive">
        {t('admin.workspaceAccessChips.noWorkspaces')}
      </span>
    );
  }

  // An allow or deny list that names nobody: the mode is set but says nothing yet.
  if (workspaces.length === 0) {
    return (
      <span className="text-body-md text-muted-foreground">
        {t('admin.workspaceAccessChips.none')}
      </span>
    );
  }

  return workspaceAccess === 'only' ? (
    <WorkspaceChipList
      workspaces={workspaces}
      variant="positive"
      label={t('admin.workspaceAccessChips.onlyIn')}
    />
  ) : (
    <WorkspaceChipList
      workspaces={workspaces}
      variant="destructive"
      label={t('admin.workspaceAccessChips.allExcept')}
    />
  );
}
